import React from 'react';

const HeroSection = () => (
  <section className="hero">
    <div className="content">
      <h2>Solutions for organizations implemented with ease</h2>
      <p>
        We deliver on technology leadership, quality, and continuous training,
        also present in the development and delivery of innovative services.
      </p>
      {/* <button>Learn more</button> */}
    </div>
    <div className="illustration"></div>
  </section>
);

export default HeroSection;